import { inject, Injectable } from '@angular/core';
import { AuthService } from '@isophi/core-legacy';
import { SwitchDemoKindergartenService } from '@isophi/mng-api';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs';

import { environment } from '../../../environments/environment';
import { UserService } from '../../core/services/user.service';

@Injectable({
  providedIn: 'root',
})
export class SwitchToDemoKindergartenService {
  private readonly spinner = inject(NgxSpinnerService);
  private readonly switchDemoKindergartenService = inject(SwitchDemoKindergartenService);
  private readonly userService = inject(UserService);
  private readonly authService = inject(AuthService);

  switch() {
    this.spinner.show();
    this.switchDemoKindergartenService
      .switchDemoKindergartenRetrieve(environment.client_id)
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe((response) => {
        const url = new URL(response.redirectUrl);
        if (!this.userService.loggedKindergarten.isDemo) {
          url.searchParams.append('showDemoPopup', 'true');
          url.searchParams.append('originUserUuid', this.authService.loggedUser.uuid);
        }
        const a = document.createElement('a');
        a.href = url.toString();
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  }
}
